import React from 'react';
import MiniDomManager from './MiniDomManager';
import {
  ShowMiniObserver,
  HideMiniObserver,
  UpdateMiniObserver,
  ShowPlayerControlsObserver,
  UpdateMiniAfterRecordObserver
} from './MiniObserver';
import Device from '../../devices/device';
import ChannelsSingleton from '../../components/Epg/ChannelsSingleton.js';
import Utils , {isSkipNoSuscriptionChannelEneable} from '../../utils/Utils.js';
import { EPGUtil } from '../../AAF/Nepg/EPGUtil';
import { playFullMedia, playCatchupEvent } from '../../actions/playmedia';
import { connect } from 'react-redux';
import {
  NOW_EVENT_TAG,
  NEXT_EVENT_TAG,
  FOR_LATE_EVENT_TAG,
  EVENT_ALREADY_STREAMED_TAG,
  PREVIOUS_EVENT_TAG,
  PAST_EVENTS,
  CURRENT_EVENTS,
  NEXT_EVENTS,
  initGetDataFromApa
} from './Helpers/Constans';
import DeviceStorage from '../DeviceStorage/DeviceStorage';
import './mini.css';
import LayersControl from '../../utils/LayersControl';
import settings from '../../devices/all/settings';
import { MODAL_PIN } from '../../actions/modal';
import FlagEventMini from './FlagEventMini';
import EpgPersistence from '../../AAF/Nepg/EpgPersistence';
import FallbackUtil from './../../components/Video/FallbackUtil';
import PersistentMiniEpgChannel from './PersistentMiniEpgChannel';
import PersistentMiniEpgEvent from './PersistentMiniEpgEvent';
import PersistentMiniEpgArrow from './PersistentMiniEpgArrow';
import PersistentMiniEpgRecordIcon from './PersistentMiniEpgRecordIcon';
import ModalEpgUtils from '../Epg/ModalEpgUtils';
import TvChannelUtil from '../../utils/TvChannelUtil';
import { AAF_CONTENT_IS_CATCHUP, AAF_CONTENT_IS_STARTOVER, AAF_CONTENT_IS_TV, AAF_CONTENT_IS_VOD } from '../../AAFPlayer/constants';
import { isPastEvent, isCurrentEvent } from '../EventOptions/EventOptionsUtils';
import { cls } from '../../packages/components';
import * as EpgEventUtils from 'src/components/Epg/EpgEventUtils';
import { showPassEventNotAvailableNotification, showFutureEventNotAvailableNotification } from '../../actions/notification';
import Asset from '../../requests/apa/Asset';
import ChannelSingleton from '../../components/Epg/ChannelsSingleton.js';
import PlayerStreamingUtils from '../../utils/PlayerStreamingUtils';
import { MODAL_INACTIVITY } from 'src/actions/modal';
import { ThirdPartyEpgHelper } from '../../AAFPlayer/helpers/ThirdPartyEpgHelper';
import logger from 'src/utils/logger/logger';
const config_remote_control =
  DeviceStorage.getItem('config_remote_control') !== 'simple' ? true : false;
class PersistentMiniEpg extends React.Component {
  constructor(props) {
    super(props);
    /** To handle DOM **/
    this._container = 'main-container';
    this._miniContainer = 'mini-container';
    this._miniDomManager = new MiniDomManager();
    /** Channel list **/
    this._channels = [];
    /** To handle control key press **/
    this.keys = Device.getDevice().getKeys(); //handle keypress
    /** Vertical Naviation and control channel is showed in the Mini EPG **/
    this._currentChannel = null; // current channel showed in the Mini EPG
    this._currentIndex = 0; //current channel array index showed in the Mini EPG
    this._currentIndexIsPlaying = 0; //current channel array index  playing at that moment
    this._currentGroupIdIsPlaying = null; //current group id playing at that moment
    this._currentChannelIsPlaying = null; //current channel id playing at that moment

    this._firstTimePressed = true; // collectorKey
    this._pressTimer = null; // collectorKey
    /** Horizontal Naviation and control the events are showed in the Mini EPG **/
    this.previousEvent = null; //previous event of current event in the future or past
    this.nextEvent = null; //next event of current event in the future or past
    this.currentEvent = null; //current event of channel in the future or past
    this.initialCurrentEvent = null; //current event of channel in the current time
    this.initialPreviousEvent = null; //previous event of channel in the current time
    this.initialNextEvent = null; //next event of channel in the current time
    this.eventFocused = null; // event focused
    this.whereAmI = CURRENT_EVENTS; // to know if Am I in the current, future or past events;
    /** To handle setTimeout and delay **/
    this._handleFocusControl = null; // handle a delay in a callback
    this._keyWithDelayId = null; // handle a delay in a callback
    /** Flags **/
    this._isPromiseLoading = false; // to know if the query has done
    this._wasReseted = false; // to know if Mini Epg was reseted
    this.firstTimePressed = true;
    this._backgroundUpdateTimer = null;
    this._backgroundUpdateTime = 1 * 60000;
    this.notShow = false;
    this.forcedEvent = null;
    this.playerStreamingUtils = new PlayerStreamingUtils();
  }

  _addEventListener = () => {
    ShowMiniObserver.unsubscribe(this._showMini);
    ShowMiniObserver.subscribe(this._showMini);
    HideMiniObserver.unsubscribe(this._hideMini);
    HideMiniObserver.subscribe(this._hideMini);
    UpdateMiniObserver.unsubscribe(this._updateMiniWithGroupIdFromStorage);
    UpdateMiniObserver.subscribe(this._updateMiniWithGroupIdFromStorage);
    UpdateMiniAfterRecordObserver.unsubscribe(this._updateMiniAfterRecord);
    UpdateMiniAfterRecordObserver.subscribe(this._updateMiniAfterRecord);
    document.removeEventListener('keydown', this._handleKeyPress, true);
    document.addEventListener('keydown', this._handleKeyPress, true);
    document.getElementById(this._container).removeEventListener('sn:focused', this._handleFocus);
    document.getElementById(this._container).addEventListener('sn:focused', this._handleFocus);
  };

  _removeEventListener = () => {
    ShowMiniObserver.unsubscribe(this._showMini);
    HideMiniObserver.unsubscribe(this._hideMini);
    UpdateMiniObserver.unsubscribe(this._updateMiniWithGroupIdFromStorage);
    UpdateMiniAfterRecordObserver.unsubscribe(this._updateMiniAfterRecord);
    document.removeEventListener('keydown', this._handleKeyPress, true);
    document.getElementById(this._container).removeEventListener('sn:focused', this._handleFocus);
  };

  _fillChannels = () => {
    if (this._channels.length === 0) {
      new ChannelsSingleton().getFilters().then(async filters => {
        if (Array.isArray(filters) && filters[0] && filters[0].id) {
          logger.debug(
            '****** [PersistentMiniEgp] before get channels filterId all channels: ' +
            filters[0].id
          );
          let channels = await EPGUtil.getChannelsByFilterId(filters[0]);
          if (Array.isArray(channels) && channels.length > 0) {
            logger.debug('****** [PersistentMiniEgp] set channels by filterID');
            this._setChannels(channels);
            this._updateMiniWithGroupIdFromStorage();
          } else {
            let channels = await new ChannelsSingleton().getChannels();
            if (Array.isArray(channels) && channels.length > 0) {
              logger.debug('****** [PersistentMiniEgp] set channels by getChannels');
              this._setChannels(channels);
              this._updateMiniWithGroupIdFromStorage();
            }
          }
        }
      });
      new ChannelsSingleton()
        .getMaxTimeshift()
        .then(maxTimeshift => (this.maxTimeshiftAllowed = maxTimeshift));
    }
  };

  _getCurrentEventNow = async (forcedEvent = null) =>{
    const isForcedEvent = forcedEvent && forcedEvent.group_id;
    const groupIdFromStorage = isForcedEvent ? forcedEvent.group_id : TvChannelUtil.getLastChannel();
    if(groupIdFromStorage){
      const currentEvent =  isForcedEvent ? forcedEvent : await EPGUtil.getCurrentEventByGroupId(groupIdFromStorage);
      if(currentEvent){
        this.eventFocused = {...currentEvent};
      }
    }
  }

  _initialize = () => {
    logger.debug('***** [PersistentMiniEgp] _initialize');
    const callbacks = {
      hide: ()=>{
        this._updateMiniWithGroupIdFromStorage(this.forcedEvent)
        this._getCurrentEventNow(this.forcedEvent);
      },
      show: this._showCb
    };
    this._miniDomManager.init(
      this._container,
      this._miniContainer,
      callbacks
    );
    this._fillChannels();
    initGetDataFromApa();
  };

  /**internal setters */
  _setChannels = channels => (this._channels = channels || []);
  _setCurrentChannel = channel => (this.currentChannel = channel);
  _setCurrentIndex = index => (this.currentIndex = index);
  _setCurrentGroupIdIsPlaying = group_id => {
    this.currentGroupIdIsPlaying = group_id;
    if (
      this.currentEvent &&
      this.currentEvent.id &&
      this.currentEvent.channel_id &&
      this.currentEvent.group_id
    ) {
      const event = {
        eventId: this.currentEvent.id,
        number: this.currentEvent.channel_id,
        groupId: this.currentEvent.group_id,
        ext_series_id: this.currentEvent.ext_series_id || null,
        ext_season_id: this.currentEvent.ext_season_id || null,
        ext_episode_id: this.currentEvent.ext_episode_id || null
      };
      if (typeof this.props.setCurrentEventInPlayerControls === 'function') {
        this.props.setCurrentEventInPlayerControls(event);
      }
    }
  };
  _setCurrentChannelIsPlaying = channel => (this.currentChannelIsPlaying = channel);
  _setCurrentIndexIsPlaying = index => (this.currentIndexIsPlaying = index);
  _setCurrentChannelByCurrentIndex = () =>
    this._channels[this.currentIndex] &&
    this._setCurrentChannel(this._channels[this.currentIndex]);
  _setCurrentChannelByCurrentIndexIsPlaying = () => {
    if (this._channels[this.currentIndexIsPlaying]) {
      this._setCurrentChannel(this._channels[this.currentIndexIsPlaying]);
      this._setCurrentIndex(this.currentIndexIsPlaying);
    }
  };

  _startBackgroundUpdate = () => {
    if (!this._backgroundUpdateTimer) {
      this._backgroundUpdateTimer = setInterval(() => {
        this._resetChannelIsPlaying();
      }, this._backgroundUpdateTime);
    }
  };

  _stopBackgroundUpdate = () => {
    clearInterval(this._backgroundUpdateTimer);
    this._backgroundUpdateTimer = null;
  };

  _focusOnEvent = (type, withDelay = false) => {
    const idToFocus = `mini-${type}-event`;
    this._handleFocus({ srcElement: { id: idToFocus }});
    if(document.activeElement && document.activeElement.id === idToFocus){
      return;
    }
    if (withDelay) {
      setTimeout(() => {
        if (Utils.isModalHide()) {
          window.SpatialNavigation.focus(`#${idToFocus}`);
        }
      }, 300);
    } else {
      if (Utils.isModalHide()) {
        window.SpatialNavigation.focus(`#${idToFocus}`);
      }
    }
  };

  _renderChannelInDom = channel => this._miniDomManager.renderChannel(channel);
  _renderMiniEpgEvents = async (group_id, updateControls, forcedEvent = null) => {
    const isForcedEvent = !!forcedEvent;
    try {
      this._isPromiseLoading = true;
      let currentEvent = null,
        nextEvent = null,
        previousEvent = null;
      currentEvent = isForcedEvent ? {...forcedEvent} : await EPGUtil.getCurrentEventByGroupId(group_id);
      nextEvent = await EPGUtil.getNextEventByEvent(currentEvent);
      previousEvent = await EPGUtil.getPreviousEventByEvent(currentEvent);
      logger.debug('PersistentMiniEpg  _renderMiniEpgEvents currentEvent:', currentEvent);
      logger.debug('PersistentMiniEpg _renderMiniEpgEvents nextEvent:', nextEvent);
      logger.debug('PersistentMiniEpg _renderMiniEpgEvents previousEvent:', previousEvent);
      if(!isForcedEvent){
      this.initialCurrentEvent = { ...currentEvent };
      this.initialPreviousEvent = { ...previousEvent };
      this.initialNextEvent = { ...nextEvent };
      }
      switch (this.whereAmI) {
        case CURRENT_EVENTS:
          break;
        case PAST_EVENTS:
        case NEXT_EVENTS:
          if(isForcedEvent){
            break;
          }
          currentEvent = this.initialDateForFutureOrPastEvets
            ? await EPGUtil.getEventByGroupIdByStartTime(
              group_id,
              this.initialDateForFutureOrPastEvets
            )
            : null;
          nextEvent = await EPGUtil.getNextEventByEvent(currentEvent);
          previousEvent = await EPGUtil.getPreviousEventByEvent(currentEvent);
          break;
        default:
      }
      if (!currentEvent || !nextEvent) {
        this.whereAmI = CURRENT_EVENTS;
      }
      this._isPromiseLoading = false;
      this.previousEvent = { ...previousEvent };
      this.currentEvent = { ...currentEvent };
      this.nextEvent = { ...nextEvent };
      const eventToDisplay = { ...currentEvent };
      eventToDisplay.nextEvent = { ...nextEvent };
      this._checkEventTags(eventToDisplay);
      this._renderEventsInDom(eventToDisplay, this.currentChannel);
      this._renderChannelInDom(this.currentChannel);
      updateControls &&
      this._miniDomManager.renderControls(
        this.currentChannelIsPlaying,
        this.initialCurrentEvent
      );
      this._focusOnEvent('principal');
    } catch (e) {
      this._isPromiseLoading = false;
      this._renderChannelInDom(this.currentChannel);
    }
  };
  //* Funcion para mandar a llamar Eventos de miniDom
  _renderEventsInDom = (eventToDisplay, currentChannel) => {
    this.eventToDisplay = eventToDisplay;
    this._miniDomManager.renderEvents(eventToDisplay, currentChannel);
  };
  _showMini = () => {
    this._fillChannels();
    this._stopBackgroundUpdate();
    if (this._miniDomManager.getVisibility('controls')) return;
    this._miniDomManager.showMini();
    if (
      !(document.activeElement === document.getElementById('mini-secondary-event')) &&
      !(document.activeElement === document.getElementById('mini-principal-event'))
    ) {
      this._focusOnEvent('principal', true);
    }
  };
  _hideMini = () => {
    this._startBackgroundUpdate();
    this._miniDomManager.hideMini();
  };

  _updateMiniWithGroupIdFromStorage = (forcedEvent = null) => {
    const isForcedEvent = forcedEvent && forcedEvent.group_id;
    const groupIdFromStorage = isForcedEvent ? forcedEvent.group_id : TvChannelUtil.getLastChannel();
    this.whereAmI = CURRENT_EVENTS;
    if (groupIdFromStorage) {
      let indexFound = 0;
      let channelFiltered = this._channels.filter((channel, index) => {
        if (channel.group_id == groupIdFromStorage) {
          indexFound = index;
          return true;
        }
      });
      if (channelFiltered.length > 0) {
        channelFiltered = channelFiltered.reduce(it => it);
        this._setCurrentIndex(indexFound);
        this._setCurrentIndexIsPlaying(indexFound);
        this._setCurrentChannelIsPlaying(channelFiltered);
        this._setCurrentGroupIdIsPlaying(groupIdFromStorage);
        if(isForcedEvent){
          this.resetMiniWithForcedEvent(forcedEvent);
        }
        else{
          this.forcedEvent= null;
          this._resetChannelIsPlaying();
        }
      }
    } else {
      this._setCurrentIndex(0);
      this._setCurrentIndexIsPlaying(0);
      if(isForcedEvent){
        this.resetMiniWithForcedEvent(forcedEvent);
      }
      else{
        this.forcedEvent= null;
        this._resetChannelIsPlaying();
      }
    }
  };

  resetMiniWithForcedEvent = (forcedEvent) => {
    this._setCurrentChannelByCurrentIndexIsPlaying();
    if(isPastEvent(forcedEvent)){
      this.whereAmI = PAST_EVENTS;
      this.initialDateForFutureOrPastEvets = forcedEvent.date_begin;
    }
    else if(isCurrentEvent(forcedEvent)){
      this.whereAmI = CURRENT_EVENTS;
    }
    else{
      this.whereAmI = NEXT_EVENTS;
      this.initialDateForFutureOrPastEvets = forcedEvent.date_begin;
    }
    this._updateMiniguide(true, forcedEvent);
    this._wasReseted = true;
    this._focusOnEvent('principal', true);
  }

  _updateMiniAfterRecord = () => {
    this._updateMiniguide();
  };

  _updateMiniguide = (updateControls, forcedEvent = null, notReAssignForcedEvent = false) => {
    if(!notReAssignForcedEvent){
      this.forcedEvent= forcedEvent;
    }
    if (this.currentChannel && this.currentChannel.group_id) {
      this._renderMiniEpgEvents(this.currentChannel.group_id, updateControls, forcedEvent);
    }
  };

  setEventTag = (event, type) => {
    if(isPastEvent(event)){
      event.tag = PREVIOUS_EVENT_TAG;
      return PAST_EVENTS;
    }
    else if(isCurrentEvent(event)){
      this.whereAmI = CURRENT_EVENTS;
      event.tag = NOW_EVENT_TAG;
      this._setEventProgress(event, type);
      return CURRENT_EVENTS;
    }
    else{
      if(event && event.date_begin){
        event.tag = FOR_LATE_EVENT_TAG;
        return NEXT_EVENTS;
      }
      else{
        if(type === 'principal'){
          event.tag = NOW_EVENT_TAG;
          return CURRENT_EVENTS;
        }
        else{
          event.tag = FOR_LATE_EVENT_TAG;
          return NEXT_EVENTS;
        }
      }
    }
  }

  _checkEventTags = eventToDisplay => {
    this._clearEventProgress('principal');
    this._clearEventProgress('secondary');
    const typePrincipalEvent =this.setEventTag(eventToDisplay, 'principal');
    const typeSecondaryEvent = this.setEventTag(eventToDisplay.nextEvent, 'secondary');
    if(typePrincipalEvent === CURRENT_EVENTS || typeSecondaryEvent === CURRENT_EVENTS){
      this.whereAmI = CURRENT_EVENTS;
    }
    else if(typePrincipalEvent === PAST_EVENTS && typeSecondaryEvent === PAST_EVENTS){
      this.whereAmI = PAST_EVENTS;
    }
    else if(typePrincipalEvent === NEXT_EVENTS && typeSecondaryEvent === NEXT_EVENTS){
      this.whereAmI = NEXT_EVENTS;
    }
  };

  _updateFutureOrPastEvent = async (type, cb = null) => {
    try {
      this._isPromiseLoading = true;
      if (this.currentChannel && this.currentChannel.group_id) {
        switch (type) {
          case 'FUTURE':
            if (this.currentEvent && this.nextEvent) {
              const eventToDisplay = { ...this.nextEvent };
              this.previousEvent = { ...this.currentEvent };
              this.currentEvent = { ...this.nextEvent };
              const nextEvent = await EPGUtil.getNextEventByEvent(this.currentEvent);
              if (!nextEvent) {
                this._isPromiseLoading = false;
                return;
              }
              eventToDisplay.nextEvent = { ...nextEvent };
              this.nextEvent = { ...nextEvent };
              this._checkEventTags(eventToDisplay);
              this._renderEventsInDom(eventToDisplay, this.currentChannel);
            }
            break;
          case 'PAST':
            if (this.previousEvent && this.currentEvent) {
              const eventToDisplay = { ...this.previousEvent };
              eventToDisplay.nextEvent = { ...this.currentEvent };
              this.nextEvent = { ...this.currentEvent };
              this.currentEvent = { ...this.previousEvent };
              const previousEvent = await EPGUtil.getPreviousEventByEvent(
                this.currentEvent
              );
              if (!previousEvent) {
                this._isPromiseLoading = false;
                return;
              }
              this.previousEvent = { ...previousEvent };
              this._checkEventTags(eventToDisplay);
              this._renderEventsInDom(eventToDisplay, this.currentChannel);
            }
            break;
            default:
        }
        this.initialDateForFutureOrPastEvets =
          this.currentEvent && this.currentEvent.date_begin
            ? this.currentEvent.date_begin
            : null;
        if (typeof cb === 'function') {
          cb();
        }
      }
      this._isPromiseLoading = false;
    } catch (e) {
      this._isPromiseLoading = false;
      if (typeof cb === 'function') {
        cb();
      }
    }
  };

  _resetChannelIsPlaying = () => {
    if(this.forcedEvent){
      this.resetMiniWithForcedEvent(this.forcedEvent);
    }
    else{
      this._setCurrentChannelByCurrentIndexIsPlaying();
      this.whereAmI = CURRENT_EVENTS;
      this._updateMiniguide(true);
      this._wasReseted = true;
      this._focusOnEvent('principal', true);
    }
  };

  _changePlayingChannel = (fromChannelUpDown = false) => {
    if (typeof this.props.playFullMedia === 'function' && this.currentChannel && this.currentChannel.group_id) {

      FallbackUtil.clearFallback();
      this._updateEpg(this.currentChannel);
      let newService = {
        playerstate: 'PLAYING',
        source: {
          videoid: this.currentChannel.group_id
        },
        size: {
          top: 0,
          left: 0,
          width: 1280,
          height: 720
        },
        ispreview: false,
        islive: true,
        ispip: false,
        event: null,
        // TBRFRE-1792 (7.2.2): al cambiar de canal con CH+/CH- no se debe
        // mostrar la modal de activación de HBO Max.
        fromChannelUpDown
      };
      this.props.playFullMedia(newService);
      this.forcedEvent = null;
    }
  };

  _stopService = () => {
    if (typeof this.props.playFullMedia == 'function') {
      let nullService = {
        playerstate: 'STOPPING',
        islive: true,
        ispip: false,
        event: null
      };
      this.props.playFullMedia(nullService);
    }
  };

  _goToCard = async () => {
    if (this.eventFocused && this.eventFocused.id && this.eventFocused.group_id) {
      let event = null;
      if (EPGUtil.isFullEvent(this.eventFocused)) {
        event = { ...this.eventFocused };
      } else {
        event = await EPGUtil.getEventByEventId(
          this.eventFocused.id_composite,
          this.eventFocused.id,
          this.eventFocused.group_id
        );
      }
      event.time = new Date();
      if (event) {
        FlagEventMini.setFromMini(true);
        let eventData = JSON.stringify({ event });
        this.props.goToCard(`/epg/${event.group_id}?eventData=${encodeURI(eventData)}`);
      }
    }
  };

  _setEventProgress = (event, type )=> {
    if (event.date_begin && event.date_end && !ThirdPartyEpgHelper.isThirdPartyApp(event.group_id))
      this._miniDomManager.renderEventProgress(event.date_begin, event.date_end, type);
  };

  _clearEventProgress = (type) => {
    this._miniDomManager.hideEventProgress(type);
  };

  _handleFocus = (e) => {
    if (LayersControl.isUXVisible()) return;
    logger.debug('[MiniGuide] _handleFocus');
    const id = e.srcElement.id;
    if (id === 'mini-principal-event') {
      if (this.eventToDisplay) {
        this.eventFocused = { ...this.eventToDisplay };
        if (this.eventToDisplay.id === this.initialCurrentEvent.id) {
          this.isCurrentEvent = true;
        } else {
          this.isCurrentEvent = false;
        }
      }
    }
    if (id === 'mini-secondary-event') {
      if (this.eventToDisplay && this.eventToDisplay.nextEvent) {
        this.eventFocused = { ...this.eventToDisplay.nextEvent };
        if (this.eventToDisplay.nextEvent.id === this.initialCurrentEvent.id) {
          this.isCurrentEvent = true;
        } else {
          this.isCurrentEvent = false;
        }
      }
    }
    if (typeof this.props.setCurrentEventInPlayerControls === 'function' && this.eventFocused) {
      const event = {...this.eventFocused};
      this.props.setCurrentEventInPlayerControls(event);
    }
  };

  _keyWithDelay = (callback, delayTime) => {
    const cb = () => {
      callback && callback();
      clearTimeout(this._keyWithDelayId);
      this._keyWithDelayId = null;
    };
    if (!this._keyWithDelayId) {
      this._keyWithDelayId = setTimeout(cb, delayTime);
    }
  };

  _showCb = () => {
    if (this._wasReseted) {
      if (!this._handleFocusControl) {
        this._handleFocusControl = setTimeout(() => {
          this._focusOnEvent('principal');
        }, 100);
        this._wasReseted = false;
        this._handleFocusControl = null;
      }
    }
  };

  _moveMiniGuide = direction => {
    if (!Array.isArray(this._channels) || this._channels.length === 0) return;
    if (isSkipNoSuscriptionChannelEneable()) {
      this.currentIndex = this._getNextIndex(this.currentIndex, direction);
    }else{
      switch (direction) {
        case 'UP':
          if (this._channels[this.currentIndex - 1]) {
            this.currentIndex -= 1;
          } else {
            this.currentIndex = this._channels.length - 1;
          }
          break;
        case 'DOWN':
          if (this._channels[this.currentIndex + 1]) {
            this.currentIndex += 1;
          } else {
            this.currentIndex = 0;
          }
          break;
        default:
          break;
      }
    }
  };



  /**
   * @param  {number} index
   * @param  {string} [UP/DOWN] direction
   * @param  {number} {newIndex}
   */
  _getNextIndex(index, direction){

    let nextIndex = index + (direction === 'UP' ? -1 : 1);

    if (!this._channels[nextIndex]){
      if (direction === 'UP'){
        nextIndex = this._channels.length - 1;
      }
      else{
        nextIndex = 0;
      }
    }

    const {group_id} = this._channels[nextIndex];

    if (ChannelsSingleton.canPlayChannel(group_id)) {
      return nextIndex;
    }
    else{
      return this._getNextIndex(nextIndex, direction);
    }
  }

  _collectorKey(key, withUpdateMini = false) {
    switch (key) {
      case 'CH_DOWN':
        if(Utils.modalType() === MODAL_INACTIVITY){
          e.preventDefault();
            e.stopPropagation();
          return;
        }
        if (this._isModalPINOpen()) {
          return;
        }
        if (this.firstTimePressed) {
          this._setCurrentIndex(this.currentIndexIsPlaying);
        }
        this._moveMiniGuide('UP');
        this._setCurrentChannelByCurrentIndex();
        withUpdateMini && this._updateMiniguide();
        this.firstTimePressed = false;
        break;
      case 'CH_UP':
        if(Utils.modalType() === MODAL_INACTIVITY){
          e.preventDefault();
            e.stopPropagation();
          return;
        }
        if (this._isModalPINOpen()) {
          return;
        }
        if (this.firstTimePressed) {
          this._setCurrentIndex(this.currentIndexIsPlaying);
        }
        this._moveMiniGuide('DOWN');
        this._setCurrentChannelByCurrentIndex();
        withUpdateMini && this._updateMiniguide();
        this.firstTimePressed = false;
        break;
      default:
        break;
    }
    clearTimeout(this.pressTimer);
    this.pressTimer = this._delayChangePlayingChannel();
  }
  _isModalPINOpen() {
    let flag = false;
    const modalNotToClose = [MODAL_PIN];
    if (modalNotToClose.indexOf(Utils.modalType()) !== -1) {
      flag = true;
    }
    return flag;
  }

  _delayChangePlayingChannel = (miliseconds = null) => {
    if (miliseconds === null) {
      miliseconds = EpgPersistence.getDelayChangeChannel();
    }

    return setTimeout(() => {
      if (this._isPromiseLoading) {
        this.pressTimer = this._delayChangePlayingChannel(200);
        return;
      }
      this.firstTimePressed = true;
      this._changePlayingChannel(true);
      //!withUpdateMini && this._updateMiniguide();
    }, miliseconds);
  };

  _updateEpg(channel) {
    if (typeof this.props.onUpdateEpg == 'function') {
      this.props.onUpdateEpg(channel.group_id);
    }
  }

  _handleOkClick = e => {
    const { hideMiniEpgWithVisibilityValidation = ()=>{} } = this.props;
    if (this.isCurrentEvent) {
      this._changePlayingChannel();
    } else {
      const event = {...this.eventFocused};
      if(isPastEvent(event)){
        if(EpgEventUtils.canPlayPastEventAsCatchup({...event})){
          this.props.playCatchupEvent(event);
        }
        else{
          hideMiniEpgWithVisibilityValidation();
          this.props.showPassEventNotAvailableNotification();
        }
      }
      else{
        //its future event
        const eventSelectect = {...this.eventFocused};

        const handleBluePress = (eventBlueHandler) => {
          if(eventBlueHandler && eventBlueHandler.id && eventBlueHandler.group_id){
            FlagEventMini.setFromNot(true);
            EPGUtil.getEventByEventId(eventBlueHandler.id_composite, eventBlueHandler.id, eventBlueHandler.group_id).then(
              event => {
                hideMiniEpgWithVisibilityValidation();
                //para evitar que el click se propague
                setTimeout(()=>{
                  ModalEpgUtils.blueHandler({
                    hideEpgOutsideCb: null,
                    handleGuideCb:null,
                    data: event,
                    streamType: this.props.streamType(),
                    streamContentType: this.props.getContentStreamType(),
                    changeLangCb: this.props.changeLang
                  });
                }, 300);
              }
            );
          }
        }
        hideMiniEpgWithVisibilityValidation();
        this.props.showFutureEventNotAvailableNotification(() => {handleBluePress(eventSelectect)});
      }
    }
  };

  _handleKeyPress = async e => {
    const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
    if(Utils.isModalCallCenterOpen()){
      return;
    }
    if (Utils.isModalEpgVersionOpen()) {
      return;
    }
    if(Utils.isModalEpgLive()){
      return;
    }

    if(!Utils.isNotificationHide() && Utils.modalType() !== MODAL_INACTIVITY){
      return;
    }

    if(this.props && (typeof this.props.getContentStreamType === 'function') && this.props.getContentStreamType() === AAF_CONTENT_IS_VOD){
      return;
    }


    if (Utils.isFullEpgPersistanceOpen() || LayersControl.isUXVisible() || this.notShow) {
      return;
    }
    logger.debug('[PersistentMiniEpg] _handleKeyPress currentKey', currentKey);
    if (
      this.props.enableButton('red') &&
      //(this._miniDomManager.getVisibility('mini') || this._miniDomManager.getVisibility('controls')) &&
      currentKey === 'RED'
    ) {
      return this.props.onPressRedButton();
    }
    if (
      currentKey === 'LIST' ||
      currentKey === 'VOD' ||
      currentKey === 'PPE' ||
      currentKey === 'FAV'
    ) {
      this._hideMini();
    }

    /**
     * En nuevo brief de TV en vivo, botón red
     * ahora hace el switch de mini/player controls
     */
    // if (currentKey === 'RED') {
    //   e.preventDefault();
    //   e.stopPropagation();
    //   //this.sendMetric('buscar');
    //   this.props.hideControls();
    //   this._hideMini();
    //   return this.props.goToCard('/search');
    // }
    //TODO checar si enableButton todavia estará funcionando con el nuevo BRF tv en vivo de momento queda abierto siempre
    if (
      /*this.props.enableButton('blue') && */
      currentKey === 'BLUE'
      ) {
        if(!Utils.isNotificationHide() || !Utils.isModalHide()){
          return;
      }
      if(FlagEventMini.getFromNot()){
        FlagEventMini.setFromNot(false);
        return;
      }
      //e.preventDefault();
      //e.stopPropagation();
      if (this.eventFocused && this.eventFocused.id) {
        let realEventFocused;
        const lastChannel = TvChannelUtil.getLastChannel();
        const isTPA = ThirdPartyEpgHelper.isThirdPartyApp(lastChannel);
        if ((this.eventFocused.group_id !== lastChannel) && isTPA) {
          const lastChannelEvent = await EPGUtil.getCurrentEventByGroupId(lastChannel);
          realEventFocused = lastChannelEvent;
        } else {
          realEventFocused = this.eventFocused;
        }
        EPGUtil.getEventByEventId(realEventFocused.id_composite, realEventFocused.id, realEventFocused.group_id).then(
          event => {
            this.playerStreamingUtils.checkSusc(null, event.group_id).then(isSusc => {
              if(isSusc){
                const { hideMiniEpgWithVisibilityValidation = () => {} } = this.props
                hideMiniEpgWithVisibilityValidation();
                ModalEpgUtils.blueHandler({
                  hideEpgOutsideCb: null,
                  handleGuideCb:null,
                  data: event,
                  streamType: this.props.streamType(),
                  streamContentType: this.props.getContentStreamType(),
                  changeLangCb: this.props.changeLang
                });
              }
            });
          }
        );
      }
    }

    if(currentKey === 'REC' && Utils.isMiniEpgPersistanceOpen()){
      e.stopPropagation();
      e.preventDefault();

      if (this.eventFocused && this.eventFocused.id) {
        EPGUtil.getEventByEventId(this.eventFocused.id_composite, this.eventFocused.id, this.eventFocused.group_id).then(
          event => {
            const { hideMiniEpgWithVisibilityValidation = () => {} } = this.props
            typeof hideMiniEpgWithVisibilityValidation === 'function' && hideMiniEpgWithVisibilityValidation();
            event && typeof this.props.record === 'function' && this.props.record({...event});
          }
        );
      }
      return;
    }

    if (currentKey === 'CH_UP' || currentKey === 'CH_DOWN') {
      logger.debug('[NPC] peristente mini chup chdown');
      FallbackUtil.clearFallback();
      let enableChannelChange = this.props.getContentStreamType() === AAF_CONTENT_IS_TV
        || this.props.getContentStreamType() === AAF_CONTENT_IS_STARTOVER
        || this.props.getContentStreamType() === AAF_CONTENT_IS_CATCHUP;
      // Sólo se permite el cambio en tv o en startover
      if(!enableChannelChange) {
        return;
      }
      // Parece que ya no hay ActionBar en nuevo brief TV
      // this.props.hideActionBar();
      // Ahora es P quien se encarga de poner visible la mini
      // ShowPlayerControlsObserver.fire();
      const withUpdateMini = Utils.choiceBehaviorChannelChange();
      const chUpDownCb = () => {
        this._collectorKey(currentKey, withUpdateMini);
      };
      //this._keyWithDelay(chUpDownCb,300);
      if (!this._isPromiseLoading) {
        // Reset del autohide de PC mientras se mueva con chup, chdown
        this.props.resetAutoHideTimer();
        chUpDownCb();
      }
      // Dejamos que corra el evento hasta playercontrols, y ahora
      // es player controls quien se encarga o no de mostrarse
      // e.stopPropagation();
      // e.preventDefault();
      return;
    }
    if (
      !this._miniDomManager.getVisibility('mini') ||
      this._miniDomManager.getVisibility('controls') ||
      !Utils.isModalHide()
    ) {
      logger.debug('[PersistentMiniEpg] not visible');
      return;
    }
    switch (currentKey) {
      case 'DOWN':
      case 'UP':
        // if(!playerContainer.classList.contains("show-mini-epg"))
        //     return;
        const upDownCb = () => {
          this._moveMiniGuide(currentKey);
          this._setCurrentChannelByCurrentIndex();
          this._updateMiniguide(false, null, true);
        };
        if (!this._isPromiseLoading) {
          upDownCb();
          //this._keyWithDelay(upDownCb,200);
        }
        break;
      case 'OK':
        if (!Utils.isActionBarOpen()) {
          e.stopPropagation();
          e.preventDefault();
          this._handleOkClick();
        }
        break;
      case 'RIGHT':
        const rightCb = () => {
          if (!this._isPromiseLoading)
            this._updateFutureOrPastEvent('FUTURE', () => {
              this._focusOnEvent('secondary');
            });
        };
        if (document.activeElement == document.getElementById('mini-secondary-event')) {
          //this._keyWithDelay(rightCb,50);
          if (!this._isPromiseLoading) {
            rightCb();
          }
        }
        break;
      case 'LEFT':
        if (this.hasTimeShif(this.previousEvent)) {
          return;
        }

        if (this.maxTimeshiftAllowed === 0 && this.displayedEventIndex === 0 && this.eventIsCurrent(this.displayedChannelEvents[this.displayedEventIndex])) {
          return;
        }

        const leftCb = () => {
          if (!this._isPromiseLoading)
            this._updateFutureOrPastEvent('PAST', () => {
              this._focusOnEvent('principal');
            });
        };
        if (document.activeElement == document.getElementById('mini-principal-event')) {
          //this._keyWithDelay(leftCb,50);
          leftCb();
        }
        break;
      default:
        break;
    }
  };

  eventIsCurrent(event) {
    if (event && event.date_begin) {
        const _now = Utils.nowAsTimestampSeconds();
        return event.date_begin <= _now && event.date_end >= _now;
    }
    return false;
  }

  hasTimeShif(event) {
    let result = true;
    const currentTime = Utils.nowAsTimestampSeconds();
    const maxTimeAllowed = currentTime - this.maxTimeshiftAllowed;
    if (event && event.date_begin) {
      if (this.maxTimeshiftAllowed === 0 && this.eventIsCurrent(event)) {
        result = false;
      } else {
        if (event.date_begin >= maxTimeAllowed) {
          result = false;
        }
      }
    }
    return result;
  }

  componentDidMount() {
    this._initialize();
    this._addEventListener();
    window.SpatialNavigation.makeFocusable();
    // TODO confirmar con Mariano que esto no afecta a la mini
    // this._showMini();
  }

  componentWillReceiveProps(nextProps) {
    this.notShow = nextProps.notShow;
    if (nextProps.notShow) {
      this._hideMini();
    }
  }

  shouldComponentUpdate() {
    return false;
  }

  componentWillUnmount() {
    this._removeEventListener();
    this._stopBackgroundUpdate();
  }

  render() {
    const effectsEnabled = Utils.getApaMetadataKey('aaf_effects','{"enable":true}',"enable");
    const arrowUp = Asset.get('playingLive_miniEpg_toolbar_button_upChannel', '/images/mini-epg/chevron_up.png');
    const arrowDown = Asset.get('playingLive_miniEpg_toolbar_button_downChannel', '/images/mini-epg/chevron_down.png');
    const arrowLeft = Asset.get('playingLive_miniEpg_toolbar_button_leftProgram', '/images/mini-epg/chevron_left.png');
    const arrowRight = Asset.get('playingLive_miniEpg_toolbar_button_rightProgram', '/images/mini-epg/chevron_right.png');
    return (
      <div id={this._container}>
        <div
          className={cls(
            "mini-column mini-main-container ",
            {
              "fadeInMini": effectsEnabled
            })}
          id={this._miniContainer}
          style={{ opacity: 0, visibility:'hidden' }}
        >
          <PersistentMiniEpgArrow type="up" src={arrowUp}/>
          <PersistentMiniEpgArrow type="down" src={arrowDown}/>
          <PersistentMiniEpgArrow type="left" src={arrowLeft}/>
          <PersistentMiniEpgArrow type="right" src={arrowRight}/>
          <div className="mini-channel-events-container mini-row">
            <PersistentMiniEpgChannel/>
            <div id="mini-channel-block-icon">
              <img  src={Asset.get('playingLive_channel_option_button_lockChannel', '/images/ic_block.png')} alt="lock"/>
            </div>
            <div className="mini-events-container mini-row">
              <PersistentMiniEpgEvent type="principal" effectsEnabled={effectsEnabled}/>
              <PersistentMiniEpgEvent type="secondary" effectsEnabled={effectsEnabled}/>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  showFutureEventNotAvailableNotification: (handleBluePress)=>dispatch(showFutureEventNotAvailableNotification(handleBluePress)),
  showPassEventNotAvailableNotification: ()=>dispatch(showPassEventNotAvailableNotification()),
  playFullMedia: pgm => dispatch(playFullMedia(pgm)),
  playCatchupEvent: (event, isRestart)=> dispatch(playCatchupEvent(event, isRestart))
});

export default connect(null, mapDispatchToProps)(PersistentMiniEpg);



// WEBPACK FOOTER //
// ./src/components/PersistentMiniEpg/index.jsx